export const GROUP_LIST = ['VN30', 'VN100'];
export const DEFAULT_GROUP = 'VN30';
export const DEFAULT_CURRENT_TICKER = { organ_name: 'Công ty cổ phần FPT ', ticker: 'FPT' };
